// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1frxnkob>*{vertical-align:middle}
._1k0l7vkz>*{line-height:1pc}
._d0dzdf4r>*{display:inline-block!important}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/status/dist/esm/components/compiled/Status.compiled.css"],"names":[],"mappings":"AAAA,aAAa,qBAAqB;AAClC,aAAa,eAAe;AAC5B,aAAa,8BAA8B","sourcesContent":["._1frxnkob>*{vertical-align:middle}\n._1k0l7vkz>*{line-height:1pc}\n._d0dzdf4r>*{display:inline-block!important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
